/* eslint-disable @typescript-eslint/no-explicit-any */

const convertCollateralValues = (collaterals: any) => {
    if (collaterals.length < 1) {
        return null
    }

    const { asset, unique_external_id } = collaterals[0]

    if (!asset) {
        return null
    }

    const year = asset.year ? asset.year.toString() : ''
    const condition = asset.condition === 'N' ? 'new' : 'used'

    const data = {
        condition,
        year,
        make: asset.make,
        makeId: asset.make_id ? asset.make_id.toString() : '',
        model: asset.model,
        modelId: asset.model_id ? asset.model_id.toString() : '',
        trim: asset.trim,
        automobileId: asset.automobile_id ? asset.automobile_id.toString() : '',
        color: asset.color,
        isCpo: !!asset.is_cpo,
        vin: unique_external_id ?? '',
        nadaAccessories: asset.nada_accessories ?? [],
    }

    if (condition === 'new') {
        const invoice = asset.invoice_price ?? 0

        return {
            ...data,
            invoice,
        }
    }

    if (condition === 'used') {
        const bookingSource = asset.booking_source ?? ''
        const mileage = asset.mileage ?? 0
        const wholesale = asset.wholesale_price ?? 0
        const likeInvoice = asset.like_invoice_price ?? ''

        return {
            ...data,
            bookingSource,
            mileage,
            wholesale,
            likeInvoice,
        }
    }

    return data
}

export default convertCollateralValues
